import React, { useEffect } from 'react'
import Header from './components/header/Header'
import Nav from './components/nav/Nav'
import About from './components/about/About'
import Experience from './components/experience/Experience'
import Services from './components/services/Services'
import Portfolio from './components/portfolio/Portfolio'
// import Testimonials from './components/testimonials/Testimonials'
import Contacts from './components/contacts/Contacts'
import Footer from './components/footer/Footer'
import ReactGA from "react-ga4"

const App = () => {

  const TrackingId ="G-MLL3YXSR66"
  ReactGA.initialize(TrackingId)
  // useEffect(() => {
  //   ReactGA.initialize(TrackingId); // Replace with your GA4 measurement ID
  //   ReactGA.send({ hitType: 'pageview', page: window.location.pathname });
  // }, []);
  return (
    <>
    <Header />
    <Nav />
    <About />
    <Experience />
    <Services />
    <Portfolio />
    {/* <Testimonials /> */}
    <Contacts />
    <Footer />
    </>
  )
}

export default App
